import React, { FC, useCallback, useMemo, useState } from 'react';

import { ResultsContext } from '../context/ResultsContext';

const ResultsProgressProvider: FC = (props) => {
  const [visibility, setVisibility] = useState(false);
  const show = useCallback(() => {
    setVisibility(true);
  }, [setVisibility]);
  const hide = useCallback(() => {
    setVisibility(false);
  }, [setVisibility]);
  const value = useMemo(() => ({ visibility, show, hide }), [visibility, show, hide]);

  return <ResultsContext.Provider value={value}>{props.children}</ResultsContext.Provider>;
};

export default ResultsProgressProvider;
